import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function CheckCircleIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M14.9005 10.1233C15.1067 9.76399 14.9825 9.30563 14.6233 9.09948C14.264 8.89333 13.8056 9.01747 13.5995 9.37674L11.3059 13.374C11.2052 13.5495 10.9487 13.539 10.8627 13.3558L10.429 12.4314C10.253 12.0564 9.80643 11.8951 9.43144 12.071C9.05645 12.247 8.89508 12.6936 9.07101 13.0686L9.50471 13.993C10.1063 15.2749 11.902 15.3489 12.6069 14.1206L14.9005 10.1233Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.58173 4 4 7.58173 4 12C4 16.4183 7.58173 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58173 16.4183 4 12 4ZM5.5 12C5.5 8.41015 8.41015 5.5 12 5.5C15.5899 5.5 18.5 8.41015 18.5 12C18.5 15.5899 15.5899 18.5 12 18.5C8.41015 18.5 5.5 15.5899 5.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
};
